var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-row",
            {
              staticClass: "mb16",
              attrs: { type: "flex", justify: "space-between" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交" + _vm._s(_vm.operationType) + "单")]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.onReset } },
                [_vm._v("清空" + _vm._s(_vm.operationType) + "单")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                height: "calc(100vh - 290px)",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "操作", width: "70", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: {
                            click: function ($event) {
                              return _vm.onRemoveRow(scope.$index)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "70",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "cell-editor-wrap",
                              _vm.isEditing(scope.$index, "goodsName")
                                ? "is-editing-wrap cell-editor-wrap--active"
                                : "is-readonly-wrap",
                            ],
                            attrs: { title: "双击输入商品查询关键词" },
                            on: {
                              dblclick: function ($event) {
                                return _vm.enableEdit(scope.$index, "goodsName")
                              },
                            },
                          },
                          [
                            _c("el-autocomplete", {
                              ref: _vm.getInputRef(scope.$index, "goodsName"),
                              class: _vm.isEditing(scope.$index, "goodsName")
                                ? "is-editing"
                                : "is-readonly",
                              staticStyle: { width: "100%" },
                              attrs: {
                                "fetch-suggestions": function (
                                  querystring,
                                  callback
                                ) {
                                  return _vm.goodsSearchAsync(
                                    querystring,
                                    callback,
                                    scope.row
                                  )
                                },
                                placeholder: "双击输入商品查询关键词",
                                "value-key": "name",
                                clearable: "",
                                readonly: !_vm.isEditing(
                                  scope.$index,
                                  "goodsName"
                                ),
                              },
                              on: {
                                select: function (item) {
                                  return _vm.onGoodsSelect(item, scope.row)
                                },
                                clear: function () {
                                  return _vm.onGoodsClear(scope.row)
                                },
                                input: function (val) {
                                  return _vm.onGoodsNameInput(val, scope.row)
                                },
                                blur: function ($event) {
                                  return _vm.handleGoodsBlur(
                                    scope.row,
                                    scope.$index
                                  )
                                },
                              },
                              model: {
                                value: scope.row.goodsName,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "goodsName", $$v)
                                },
                                expression: "scope.row.goodsName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "barcode", label: "商品条码", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "cell-editor-wrap",
                              _vm.isEditing(scope.$index, "stock")
                                ? "is-editing-wrap cell-editor-wrap--active"
                                : "is-readonly-wrap",
                            ],
                            attrs: { title: "双击输入商品条码" },
                            on: {
                              dblclick: function ($event) {
                                return _vm.enableEdit(scope.$index, "barcode")
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              ref: _vm.getInputRef(scope.$index, "barcode"),
                              class: _vm.isEditing(scope.$index, "barcode")
                                ? "is-editing"
                                : "is-readonly",
                              attrs: {
                                type: "text",
                                placeholder: "双击输入商品条码",
                                readonly: !_vm.isEditing(
                                  scope.$index,
                                  "barcode"
                                ),
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.handleBlur(scope.$index, "barcode")
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleEnter(
                                    scope.$index,
                                    "barcode"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.barcode,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "barcode", $$v)
                                },
                                expression: "scope.row.barcode",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "quantity",
                  label: "数量",
                  width: "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "cell-editor-wrap",
                              _vm.isEditing(scope.$index, "stock")
                                ? "is-editing-wrap cell-editor-wrap--active"
                                : "is-readonly-wrap",
                            ],
                            attrs: { title: "双击输入数量" },
                            on: {
                              dblclick: function ($event) {
                                return _vm.enableEdit(scope.$index, "quantity")
                              },
                            },
                          },
                          [
                            _c("el-input-number", {
                              ref: _vm.getInputRef(scope.$index, "quantity"),
                              class: _vm.isEditing(scope.$index, "quantity")
                                ? "is-editing"
                                : "is-readonly",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "双击输入数量",
                                min: 1,
                                controls: false,
                                readonly: !_vm.isEditing(
                                  scope.$index,
                                  "quantity"
                                ),
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.handleBlur(
                                    scope.$index,
                                    "quantity"
                                  )
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleEnter(
                                    scope.$index,
                                    "quantity"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.quantity,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "quantity", $$v)
                                },
                                expression: "scope.row.quantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "cell-editor-wrap",
                              _vm.isEditing(scope.$index, "stock")
                                ? "is-editing-wrap cell-editor-wrap--active"
                                : "is-readonly-wrap",
                            ],
                            attrs: { title: "双击输入备注" },
                            on: {
                              dblclick: function ($event) {
                                return _vm.enableEdit(scope.$index, "remark")
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              ref: _vm.getInputRef(scope.$index, "remark"),
                              class: _vm.isEditing(scope.$index, "remark")
                                ? "is-editing"
                                : "is-readonly",
                              attrs: {
                                type: "text",
                                placeholder: "双击输入备注",
                                readonly: !_vm.isEditing(
                                  scope.$index,
                                  "remark"
                                ),
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.handleBlur(scope.$index, "remark")
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleEnter(scope.$index, "remark")
                                },
                              },
                              model: {
                                value: scope.row.remark,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "remark", $$v)
                                },
                                expression: "scope.row.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("template", { slot: "append" }, [
                _c(
                  "div",
                  { staticClass: "table-append-row" },
                  [
                    _c("el-button", {
                      staticClass: "ml12",
                      attrs: { type: "text", icon: "el-icon-plus" },
                      on: { click: _vm.onAddRow },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }